module.exports = __webpack_public_path__ + "static/media/1.269c1128.png";